import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    accordion: {
      boxShadow: 'none',
    },
    channelSelect: {
      minWidth: '340px',
      '& > *': {
        width: '100%',
      },
      [theme.breakpoints.down('md')]: {
        minWidth: '150px',
      },
    },
    gridRow: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    header: {
      height: '91px',
    },
    heading: {
      fontFamily: 'Montserrat',
      fontSize: '1rem',
      fontWeight: 'bold',
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    loading: {
      alignItems: 'center',
      backgroundColor: 'rgba(109, 114, 120, 0.1)',
      display: 'flex',
      height: '100vh',
      justifyContent: 'center',
      left: 0,
      position: 'absolute',
      top: 0,
      width: '100vw',
    },
    papersColumn: {
      alignItems: 'space-between',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      padding: theme.spacing(2),
    },
    secondaryHeading: {
      fontFamily: 'Montserrat',
      fontSize: '0.9rem',
      color: theme.palette.text.secondary,
    },
    subtitle: {
      fontFamily: 'Montserrat',
      fontSize: '1.4rem',
      fontWeight: 'bold',
      margin: '0',
      textAlign: 'left',
    },
    titleGrid: {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    questions: {
      display: 'flex',
      flexDirection: 'column',
    },
    questionsText: {
      fontFamily: 'Montserrat',
      fontSize: '0.8rem',
      fontWeight: 500,
      margin: '7px 0',
      textAlign: 'left',
      width: '90%',
    },
  })
);
